import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Brand, Eyebrow, Reveal } from "./Brand";
import { COMPANY_INSTAGRAM, OFFICES, igLink, waLink } from "./contacts";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";

// Тёмный блок: призыв написать + контакты обоих направлений
export default function SiteFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" id="contacts">
      <div className="wrap">
        <div className="footer-box">
          <Reveal className="footer-cta">
            <div>
              <Eyebrow light>{t("site.cta.eyebrow")}</Eyebrow>
              <h2 className="h2">{t("site.cta.title")}</h2>
              <p>{t("site.cta.text")}</p>
            </div>
            <div className="footer-cta__actions">
              <a className="btn-pill btn-pill--light" href={waLink(OFFICES.dubai)} target="_blank" rel="noopener noreferrer">
                <FaWhatsapp /> {t("site.cta.dubai")}
              </a>
              <a className="btn-pill btn-pill--outline-light" href={waLink(OFFICES.istanbul)} target="_blank" rel="noopener noreferrer">
                <FaWhatsapp /> {t("site.cta.istanbul")}
              </a>
            </div>
          </Reveal>

          <div className="footer-grid">
            <div>
              <Brand />
              <p className="footer-about">{t("site.footer.about")}</p>
              <p className="footer-tagline">{t("site.footer.tagline")}</p>
              <a className="footer-ig" href={igLink({ instagram: COMPANY_INSTAGRAM })} target="_blank" rel="noopener noreferrer">
                <FaInstagram /> @{COMPANY_INSTAGRAM}
              </a>
            </div>
            <div className="footer-col">
              <h4>{t("site.footer.explore")}</h4>
              <Link to="/properties">{t("site.nav.catalog")}</Link>
              <Link to="/permanent-residency/ikamet">{t("site.nav.residence")}</Link>
              <Link to="/news">{t("site.nav.news")}</Link>
            </div>
            {[
              ["dubai", OFFICES.dubai],
              ["istanbul", OFFICES.istanbul],
            ].map(([city, office]) => (
              <div className="footer-col" key={city}>
                <h4>{t(`site.footer.${city}`)}</h4>
                <span className="footer-person">{t(`site.team.${office.key}.name`)}</span>
                <a href={`tel:+${office.whatsapp}`}>{office.phone}</a>
                <a href={waLink(office)} target="_blank" rel="noopener noreferrer">
                  WhatsApp
                </a>
                <a href={igLink(office)} target="_blank" rel="noopener noreferrer">
                  @{office.instagram}
                </a>
              </div>
            ))}
          </div>

          <div className="footer-bottom">
            <span>{t("site.footer.rights", { year })}</span>
            <Link to="/admin">{t("site.footer.admin")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
